import styled from 'styled-components';
const UploadButtonStyle = styled.div `
	width: 100px;
	height: 100px;
	text-align: center;
	background-color: var(--form_uploadBgColor);
	border: 1px dashed var(--form_uploadBorderColor);
	border-radius: 8px;
	cursor: pointer;

	.upload {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
		text-align: center;
	}

	button {
		border: 0px;
		background: none;
	}
`;
export default UploadButtonStyle;
//# sourceMappingURL=style.js.map